import { triangulateToUnique as g } from "@allmaps/triangulate";
import { getForwardTransformResolution as h, computeDistortionsFromPartialDerivatives as T } from "@allmaps/transform";
import { mixPoints as a, mixNumbers as P, getPropertyFromDoubleCacheOrComputation as p } from "@allmaps/stdlib";
import j from "./WarpedMap.js";
const G = [
  "log2sigma",
  "twoOmega"
], v = 10;
function R() {
  return {};
}
function M() {
  return (s, e, i) => new m(s, e, i);
}
class m extends j {
  previousResourceResolution;
  resourceResolution;
  triangulateErrorCount = 0;
  projectedGcpPreviousTriangulation;
  projectedGcpTriangulation;
  projectedGcpTriangulationByTransformationTypeAndResourceResolution = /* @__PURE__ */ new Map();
  resourceTrianglePoints = [];
  projectedGeoPreviousTrianglePoints = [];
  projectedGeoTrianglePoints = [];
  previousTrianglePointsDistortion = [];
  trianglePointsDistortion = [];
  projectedGeoPreviousTriangulationMask = [];
  projectedGeoTriangulationMask = [];
  /**
   * Creates an instance of a TriangulatedWarpedMap.
   *
   * @constructor
   * @param {string} mapId - ID of the map
   * @param {GeoreferencedMap} georeferencedMap - Georeferenced map used to construct the WarpedMap
   * @param {WarpedMapOptions} [options] - Options
   */
  constructor(e, i, o) {
    o = {
      ...R(),
      ...o
    }, super(e, i, o), this.updateTriangulation();
  }
  /**
   * Update the resourceMask.
   *
   * @param {Ring} resourceMask
   */
  setResourceMask(e) {
    super.setResourceMask(e), this.updateTriangulation();
  }
  /**
   * Reset the previous points and values.
   */
  resetPrevious() {
    super.resetPrevious(), this.previousResourceResolution = this.resourceResolution, this.projectedGcpPreviousTriangulation = this.projectedGcpTriangulation, this.projectedGeoPreviousTrianglePoints = this.projectedGeoTrianglePoints, this.previousTrianglePointsDistortion = this.trianglePointsDistortion, this.projectedGeoPreviousTriangulationMask = this.projectedGeoTriangulationMask;
  }
  /**
   * Mix the previous and new points and values.
   *
   * @param {number} t
   */
  mixPreviousAndNew(e) {
    super.mixPreviousAndNew(e), this.projectedGcpPreviousTriangulation && this.projectedGcpTriangulation && (this.previousResourceResolution = this.resourceResolution, this.projectedGcpPreviousTriangulation = {
      resourceResolution: this.projectedGcpPreviousTriangulation.resourceResolution,
      gcpUniquePoints: this.projectedGcpPreviousTriangulation.gcpUniquePoints.map(
        (i, o) => ({
          resource: i.resource,
          geo: a(
            this.projectedGcpTriangulation.gcpUniquePoints[o].geo,
            i.geo,
            e
          ),
          // Note: Not mixing the distortions Map, only the active distortion
          distortions: this.projectedGcpTriangulation.gcpUniquePoints[o].distortions,
          distortion: P(
            this.projectedGcpTriangulation.gcpUniquePoints[o].distortion || 0,
            i.distortion || 0,
            e
          )
        })
      ),
      uniquePointIndices: this.projectedGcpPreviousTriangulation.uniquePointIndices,
      uniquePointIndexInterpolatedPolygon: this.projectedGcpPreviousTriangulation.uniquePointIndexInterpolatedPolygon
    }, this.projectedGeoPreviousTrianglePoints = this.projectedGcpPreviousTriangulation.uniquePointIndices.map(
      (i) => this.projectedGcpPreviousTriangulation.gcpUniquePoints[i].geo
    ), this.previousTrianglePointsDistortion = this.projectedGcpPreviousTriangulation.uniquePointIndices.map(
      (i) => this.projectedGcpPreviousTriangulation.gcpUniquePoints[i].distortion
    )), this.projectedGeoPreviousTriangulationMask = this.projectedGeoTriangulationMask.map((i, o) => a(
      i,
      this.projectedGeoPreviousTriangulationMask[o],
      e
    ));
  }
  /**
   * Update the (previous and new) triangulation of the resourceMask. Use cache if available.
   */
  updateTriangulation() {
    if (!this.projectedGcpTriangulationByTransformationTypeAndResourceResolution)
      return;
    const e = h(
      this.resourceMaskBbox,
      this.projectedTransformer,
      {}
    );
    let i = !1;
    e && this.previousResourceResolution && (i = this.previousResourceResolution < e, this.resourceResolution = Math.min(
      e,
      this.previousResourceResolution
    )), e && !this.previousResourceResolution && (i = !0, this.resourceResolution = e), !e && this.previousResourceResolution ? this.resourceResolution = this.previousResourceResolution : !e && !this.previousResourceResolution && (this.resourceResolution = void 0), this.projectedGcpTriangulation = p(
      this.projectedGcpTriangulationByTransformationTypeAndResourceResolution,
      this.transformationType,
      this.resourceResolution,
      () => {
        try {
          const {
            uniquePoints: o,
            uniquePointIndexTriangles: t,
            uniquePointIndexInterpolatedPolygon: r
          } = g([this.resourceMask], this.resourceResolution), n = this.resourceResolution, c = o.map(
            (d) => this.resourceToResourceProjectedGeoDistortions(
              d,
              this.projectedTransformer,
              this.getReferenceScale()
            )
          ), l = t.flat();
          return {
            resourceResolution: n,
            gcpUniquePoints: c,
            uniquePointIndices: l,
            uniquePointIndexInterpolatedPolygon: r
          };
        } catch (o) {
          this.triangulateErrorCount++, this.triangulateErrorCount <= v && (console.error(
            `Error computing triangulation for map ${this.mapId}.`,
            `Fix this map with Allmaps Editor: https://editor.allmaps.org/#/collection?url=${this.parsedImage?.uri}/info.json`
          ), this.triangulateErrorCount === 1 && console.error(o));
        }
      }
    ), this.projectedGcpPreviousTriangulation || (this.projectedGcpPreviousTriangulation = this.projectedGcpTriangulation), i && (this.previousResourceResolution = this.resourceResolution, this.projectedGcpPreviousTriangulation = p(
      this.projectedGcpTriangulationByTransformationTypeAndResourceResolution,
      this.previousTransformationType,
      this.previousResourceResolution,
      () => ({
        resourceResolution: this.projectedGcpTriangulation.resourceResolution,
        gcpUniquePoints: this.projectedGcpTriangulation.gcpUniquePoints.map(
          (o) => this.resourceToResourceProjectedGeoDistortions(
            o.resource,
            this.projectedPreviousTransformer,
            this.getReferenceScale()
          )
        ),
        uniquePointIndices: this.projectedGcpTriangulation.uniquePointIndices,
        uniquePointIndexInterpolatedPolygon: this.projectedGcpTriangulation.uniquePointIndexInterpolatedPolygon
      }),
      () => !this.mixed,
      () => !this.mixed
    )), this.updateTrianglePoints();
  }
  /**
   * Derive the (previous and new) resource and projectedGeo points from their corresponding triangulations.
   *
   * Also derive the (previous and new) triangulation-refined resource and projectedGeo mask
   */
  updateTrianglePoints() {
    !this.projectedGcpPreviousTriangulation || !this.projectedGcpTriangulation || (this.resourceTrianglePoints = this.projectedGcpTriangulation.uniquePointIndices.map(
      (e) => this.projectedGcpTriangulation.gcpUniquePoints[e].resource
    ), this.projectedGeoTrianglePoints = this.projectedGcpTriangulation.uniquePointIndices.map(
      (e) => this.projectedGcpTriangulation.gcpUniquePoints[e].geo
    ), this.projectedGeoPreviousTrianglePoints = this.projectedGcpPreviousTriangulation.uniquePointIndices.map(
      (e) => this.projectedGcpPreviousTriangulation.gcpUniquePoints[e].geo
    ), this.projectedGeoTriangulationMask = this.projectedGcpTriangulation.uniquePointIndexInterpolatedPolygon.map(
      (e) => e.map(
        (i) => this.projectedGcpTriangulation.gcpUniquePoints[i].geo
      )
    ).flat(), this.projectedGeoPreviousTriangulationMask = this.projectedGcpPreviousTriangulation.uniquePointIndexInterpolatedPolygon.map(
      (e) => e.map(
        (i) => this.projectedGcpPreviousTriangulation.gcpUniquePoints[i].geo
      )
    ).flat(), this.updateTrianglePointsDistortion());
  }
  /**
   * Derive the (previous and new) distortions from their corresponding triangulations.
   */
  updateTrianglePointsDistortion() {
    !this.projectedGcpPreviousTriangulation || !this.projectedGcpTriangulation || (this.trianglePointsDistortion = this.projectedGcpTriangulation.uniquePointIndices.map(
      (e) => this.distortionMeasure ? this.projectedGcpTriangulation.gcpUniquePoints[e].distortions.get(
        this.distortionMeasure
      ) : 0
    ), this.previousTrianglePointsDistortion = this.projectedGcpPreviousTriangulation.uniquePointIndices.map(
      (e) => this.previousDistortionMeasure ? this.projectedGcpPreviousTriangulation.gcpUniquePoints[e].distortions.get(this.previousDistortionMeasure) : 0
    ));
  }
  resourceToResourceProjectedGeoDistortions(e, i, o) {
    const t = i.transformToGeo(e), r = i.transformToGeo(e, {
      evaluationType: "partialDerivativeX"
    }), n = i.transformToGeo(e, {
      evaluationType: "partialDerivativeY"
    }), u = T(
      G,
      r,
      n,
      o
    );
    return {
      resource: e,
      geo: t,
      distortions: u,
      distortion: 0
    };
  }
  updateTransformerProperties(e = !0) {
    super.updateTransformerProperties(e), this.updateTriangulation();
  }
  updateDistortionProperties() {
    super.updateDistortionProperties(), this.updateTrianglePointsDistortion();
  }
}
export {
  M as createTriangulatedWarpedMapFactory,
  m as default
};
//# sourceMappingURL=TriangulatedWarpedMap.js.map
